import { create } from 'zustand';

export type TickerEntry = {
  symbol: string;
  wsSymbol?: string;
  lastPrice?: string;
  high24h?: string;
  low24h?: string;
  volume24h?: string;
  vwap24h?: string;
  change24hPct?: string;
};

type TickerState = {
  tickers: Record<string, TickerEntry>;
  setTickers: (tickers: TickerEntry[]) => void;
};

export const useTickerStore = create<TickerState>()((set) => ({
  tickers: {},
  setTickers: (tickers) => {
    const next: Record<string, TickerEntry> = {};
    for (const t of tickers) {
      next[t.symbol] = t;
    }
    set({ tickers: next });
  },
}));
